import { withSuspenseLazy } from 'react-with-suspense-lazy';

import { Loader } from '@components/Loader';
import { permissionsRoles } from '@config/permissions';
import { RoutesConfiguration } from '@components/RouterOutlet';
import { UserRoutePaths } from '../routesPaths';

const UserPage = withSuspenseLazy(
  () => import('./UserPage'),
  Loader,
);

const UserAdd = withSuspenseLazy(
  () => import('./UserAdd'),
  Loader,
);

const UserEdit = withSuspenseLazy(
  () => import('./UserEdit'),
  Loader,
);

export const UserRouteConfig: RoutesConfiguration = [
  {
    path: UserRoutePaths.userRoot,
    component: UserPage,
    exact: true,
    permittedRoles: permissionsRoles.user,
  },
  {
    path: UserRoutePaths.userAddPath,
    component: UserAdd,
    permittedRoles: permissionsRoles.user,
  },
  {
    path: UserRoutePaths.userEditPath,
    component: UserEdit,
    permittedRoles: permissionsRoles.user,
  },
];
